// AGENT.md mission domains - lead-generating portfolio pilots that share
// the editorial cream design system. Used by legal pages (Impressum,
// Datenschutz, AGB) to opt into the mission cream hero/serif overlay.
export const MISSION_HOSTS = new Set([
    'hausautarkie.com',
    'heizen-mit-waermepumpe.de',
    'heizung-solar-bremen.de',
    'heizunga.de',
    'heizungsbaubremen.de',
    'heizungssuche.de',
    'heizungzukunft.com',
    'my-solar24.de',
    'pumpenprofi24.com',
    'pvcheckpro.com',
    'pvheizung.de',
    'pvkostenrechner.com',
    'shs-heizung.de',
    'solar-angebot-vergleich.de',
    'solar-heiztherm.de',
    'solar-millennium.de',
    'solar-planen.de',
    'solarcheck26.de',
    'solarexperten24.com',
    'stromretter24.com',
    'waermepreis.com',
    'waermepumpenampel.de',
    'waermepumpensofort.de',
    'waermepumpevergleich.de',
    'wpkostenrechner.com',
    'www-solar.de',
]);

export function isMissionHost(domain) {
    const host = (domain?.request_host || domain?.name || '').toLowerCase().replace(/^www\./, '');
    return MISSION_HOSTS.has(host);
}
